import { memo } from 'react';

import PhotoCard from '../PhotoCard';
import SectionWithGallery from '@Components/SectionWithGallery';

import type { MediaData } from '@Pages/PageWikiArticle';
import type { FC, HTMLAttributes } from 'react';

export interface PhotoSliderProps extends HTMLAttributes<HTMLDivElement> {
  medias: MediaData[];
  className?: string;
}

const PhotoSlider: FC<PhotoSliderProps> = (props) => {
  const { medias, ...restProps } = props;

  return (
    <SectionWithGallery {...restProps}>
      {medias.map((media) => (
        <div key={media.img}>
          <PhotoCard media={media} />
        </div>
      ))}
    </SectionWithGallery>
  );
};

export default memo(PhotoSlider);
